module.exports = __webpack_public_path__ + "img/minting_calculate.eaeaa1ed.png";